import styled from "styled-components";

const HomeWrapper = styled.div`
  ${({ theme }) => theme.mediaWidth("upToSmall", `padding: 0 1rem;`)}
`;

export default {
  HomeWrapper,
};
